import { render, staticRenderFns } from "./RelatorioPix.vue?vue&type=template&id=74534eea&"
import script from "./RelatorioPix.vue?vue&type=script&lang=js&"
export * from "./RelatorioPix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports